import React, { useState, useEffect } from 'react';
import { Input, InputNumber, Select, Form, Button } from 'antd';
import { Card, CardBody, Row, Col } from 'reactstrap';
import UrlProps from './UrlProps';
import JsonProps from './JsonProps';
import { SaveOutlined } from '@ant-design/icons';
import { dataSoruce } from 'settings/shared/constants';
import 'components/Widgets/widget-style.css';


const TableRender =(props) => {

    const [getDataBindtype, setDataBindtype] = useState("URL");
    const [getErrorFlag, setErrorFlag] = useState(false);

    const [formTable] = Form.useForm();

    useEffect(() => {
        let widgetData = props.widgetItem !== null &&
        props.widgetItem !== undefined &&
        props.widgetItem.widgetData !== null &&
        props.widgetItem.widgetData.length > 0 &&
        props.widgetItem.widgetData[0];
        if(widgetData.hasOwnProperty("bind")){
            formTable.setFieldsValue({
                title: widgetData.title,
                width: widgetData.width,
                dataFrom: widgetData.dataFrom
            })
            setDataBindtype(widgetData.dataFrom);
        } else {
            formTable.setFieldsValue({
                title: "",
                width: 40,
                dataFrom: "URL"
            })
            setDataBindtype("URL")
        }
    }, [props]);

    const onChangeDataBind = (e) => {
        setDataBindtype(e)
    };

    const onFinish = () => {
        let forms = formTable.getFieldValue();
        if (forms.hasOwnProperty("bind")) {
            if (getDataBindtype === "URL") {
                if (forms.bind.path !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = formTable.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            }
            else {
                if (forms.bind.data !== "") {
                    setErrorFlag(false)
                    onSentSuccessData();
                } else {
                    let forms = formTable.getFieldValue();
                    forms["isValid"] = false;
                    setErrorFlag(true)
                    props._getLayoutData(props.widgetId, forms);
                }
            }
        } else {
            let forms = formTable.getFieldValue();
            let cardData = props.widgetItem;
            if (cardData.widgetData !== null && cardData.widgetData.length > 0) {
                let dataSoruce = cardData.widgetData[0].bind;
                _getPropsForIndex(0, dataSoruce);
                setErrorFlag(false)
                onSentSuccessData();
            } else {
                forms["isValid"] = false;
                setErrorFlag(true)
                props._getLayoutData(props.widgetId, forms);
            }

        }
    }

    const onSentSuccessData = () => {
        let forms = formTable.getFieldValue();
        forms["isValid"] = true;
        props._getLayoutData(props.widgetId, forms);
    }

    const _getPropsForIndex = (index, dataSource) => {
        let formData = formTable.getFieldValue();
        formData["widgetType"] = props.widgetType;
        formData["bind"] = dataSource;
        formTable.setFieldsValue(formData)
    }

    return <Card className="widget-data-card  mt-2">
        <CardBody>
            <Form
                form={formTable}
                name="basic"
                onFinish={onFinish}
                autoComplete="off"
                layout="vertical"
            >
                <Row>
                    <Col xs={6} className='p-0 pr-3'>
                        <Row  className='mb-3'>
                            <Col>
                                <Form.Item name="title" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Title
                                </label>} rules={[
                                    {
                                        required: false,
                                        message: 'The name is required.'
                                    }
                                ]} >
                                    <Input placeholder='Title' className="select-theme-width" />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="width" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Width
                                </label>} >
                                    <InputNumber className="select-theme-width" />
                                </Form.Item>
                            </Col>

                            <Col>
                                <Form.Item name="dataFrom" className='col m-0 pl-1' label={<label
                                    className="form-control-label font12"
                                >
                                    Data From
                                </label>} >
                                    <Select className='' onChange={onChangeDataBind}>
                                        {dataSoruce.map((item, index) => (
                                            <Select.Option value={item.value} key={index}>{item.label}</Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Col>
                    
                    <Col className='p-0' xs={6}>
                        <div className='mt-2'>
                            {getDataBindtype === "URL" && <UrlProps widgetIndex={props.widgetIndex} propData={props.widgetItem}
                                _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}

                            {getDataBindtype === "JSON" && <JsonProps widgetIndex={props.widgetIndex} propData={props.widgetItem}
                                _getPropsForIndex={_getPropsForIndex.bind(this)} errorFlag={getErrorFlag} />}
                        </div>
                    </Col>

                </Row>

                <Row className='mt-4 float-right'>
                    <Form.Item>
                        <Button htmlType="submit" title='Save' className='settings-save-btn'>
                            <SaveOutlined className='icon-style' /> Save
                        </Button>
                    </Form.Item>
                </Row>

            </Form>
        </CardBody>
    </Card>
}

export default TableRender;